import { cn } from '@/lib/utils'
import { Loader2Icon } from 'lucide-react'

interface CircularProgressProps {
    className?: string
    /** Diâmetro em px (number) ou unidade CSS (string). Padrão 40. */
    size?: number | string
    color?: 'primary' | 'inherit'
}

export default function CircularProgress({
    className,
    size = 40,
    color = 'primary',
}: CircularProgressProps) {
    return (
        <Loader2Icon
            role="progressbar"
            className={cn(
                'animate-spin',
                color === 'inherit' ? 'text-current' : 'text-primary',
                className,
            )}
            size={typeof size === 'number' ? size : undefined}
            style={
                typeof size === 'string'
                    ? { width: size, height: size }
                    : undefined
            }
        />
    )
}
